import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Button, Title, BackButton } from '../../../../components/UI/ComponentsUI';
import LinePickingService from '../../../../services/LinePickingService';
import { translate } from '../../../../utils/util';

const UploadCalls = (props) => {
    const [selectedFile, setSelectedFile] = useState();
    const [messages, setMessages] = useState([]);

    const sendFile = () => {
        if (selectedFile) {
            props.upload(selectedFile, (data) => {
                setMessages(data);
            });
        }
    }

    return (
        <>
            <div>
                <BackButton {...props} />
                <div className="container-fluid h-65">
                    <div className="row">
                        <Title icon="mdi mdi-clipboard-check-outline" label={translate('uploadFile', 'line-picking:uploadCalls')} />
                    </div>
                </div>
                <div className="container-fluid" style={{ marginTop: '25px', }}>
                    <div className="container">
                        <form action="#">
                            <div className="file-field input-field">
                                <div className="btn">
                                    <span>File</span>
                                    <input required type="file" onChange={(event) => setSelectedFile(event.target.files[0])} />
                                </div>
                                <div className="file-path-wrapper">
                                    <input className="file-path validate" type="text" />
                                </div>
                            </div>
                        </form>
                        <div className="col s12 center" style={{ marginTop: '8px' }}>
                            <Button full="true" onClick={sendFile} text="Enviar" />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', paddingTop: '15px' }}>
                            {messages.map((item) => (
                                <span key={item.code} className="fourth-text-color">
                                    {item.code} - {item.message}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        upload: (file, callback) => {
            dispatch(LinePickingService.uploadFile(file, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UploadCalls)));